import { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useAuth0 } from '@auth0/auth0-react';
import { toast } from 'react-toastify';

import { parentSupervisionActions } from '../../../../../store';

function useDownloadPDF(supervisionId: number | undefined) {
  const dispatch = useDispatch();
  const { getAccessTokenSilently } = useAuth0();
  const [showConfirmDownloadDialog, setShowConfirmDownloadDialog] = useState(false);

  const handleDownloadPDF = useCallback(async () => {
    if (!supervisionId) return;
    setShowConfirmDownloadDialog(false);

    const response = await dispatch(
      parentSupervisionActions.downloadPDF({
        supervisionId: supervisionId,
        getAccessTokenSilently: getAccessTokenSilently,
      }),
    );

    if (response.payload?.document_url) {
      window.location.href = response.payload.document_url;
      return;
    }

    if (response.error?.message) {
      toast.error(response.error.message);
      return;
    }

    toast.error('Something went wrong while downloading the pdf');
  }, [dispatch, getAccessTokenSilently, supervisionId]);

  return {
    showConfirmDownloadDialog,
    setShowConfirmDownloadDialog,
    handleDownloadPDF,
  };
}

export default useDownloadPDF;
